var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"position":"relative","background":"#fff"}},[_c('infor-header'),_c('router-view'),_c('infor-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }